var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lottie"},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":500,"width":500},on:{"animCreated":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }